<sample-details-table></sample-details-table>

<pandora-aside #submInfoAside
      [title]="'Sample Info'"
      [isAsideOpen]=true
      [closeText]="'Close'"
      [closeChevron]=false
      [isToggleAvailable]=false
      [isToggleButtonExists]=false>
    <div aside-content><sample-details-sidebar #submInfoSidebarComponent></sample-details-sidebar></div>
</pandora-aside>
